// Components==============
import { AnimatePresence } from 'framer-motion';
import { useRedux } from 'hooks/useRedux';
import { useTranslate } from 'hooks/useTranslate';
import React, { useContext, useState } from 'react';
import { getSmartImage } from 'utilities/getSmartImage';
import { GlobalEvidenceContext } from 'utilities/GlobalContext/GlobalEvidence';
import EvidenceModal from '../EvidenceModal/EvidenceModal';
import './Notification.module.scss';
// =========================

export default function FeedbackNotification({
  activity,
}: {
  activity: FeedbackEntity;
}) {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const translate = useTranslate();

  const evidence = useContext(GlobalEvidenceContext);

  const evidenceEntity = evidence?.find(
    (e) => e.evidence.id === activity?.evidence_id
  )?.evidence;

  const userId = useRedux((state) => state.authentication?.user?.id);

  if (evidenceEntity) {
    return (
      <>
        <div
          styleName="notification"
          style={{ cursor: 'pointer' }}
          onClick={() => setModalIsOpen(true)}
        >
          <div styleName="image">
            {evidenceEntity.path.includes('.mp4') ? (
              <video preload="metadata">
                <source src={`${evidenceEntity.path}#t=0.5`} type="video/mp4" />
              </video>
            ) : (
              <img
                alt="notification"
                src={
                  evidenceEntity.type === 'extern'
                    ? '/images/cloud.png'
                    : getSmartImage(`${evidenceEntity.path}`)
                }
              />
            )}
          </div>
          <div styleName="right">
            <h3>
              {translate(
                `general.terms.${
                  userId === evidenceEntity.author?.id
                    ? 'your-work-has-a-comment'
                    : 'you-received-a-comment'
                }`
              )}
            </h3>
            <div styleName="description">
              <p>{activity.message}</p>
            </div>
          </div>
        </div>
        <AnimatePresence>
          {modalIsOpen && (
            <EvidenceModal
              evidence={[evidenceEntity]}
              setModalIsOpen={setModalIsOpen}
            />
          )}
        </AnimatePresence>
      </>
    );
  }
  return <></>;
}
